module.exports = __webpack_public_path__ + "images/fa-lf-bg-pricing-mobile.webp";